// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit';
import store from '../store/store'
// api
import * as productManager from './api/productmanager'
import {displayErrorMessage, displaySuccessMessage, log } from '@insticator/insticator-ui'


export const getProductManagerConfig = createAsyncThunk('productManager/getProductManagerConfig',
    async payload => {
      const { siteId } = payload
      const response = await productManager.getProductManagerConfig({ siteId })
      return response.data
    }
);

export const updateProductManagerConfig = createAsyncThunk('productManager/updateProductManagerConfig',
    async (payload, { rejectWithValue }) => {
        const { productManagerConfig, siteId } = payload
        try {
            log('productmanager config', productManagerConfig)
            // old logic - just for a reference. in case needed
            // const newGroups = productManagerConfig.groupConfigList.filter(group => !group.groupId)
            // const updatedGroups = productManagerConfig.groupConfigList.filter(group => !!group.groupId)
            // const groupLength = productManagerConfig.groupConfigList.length
            // const groupConfigList = [...updatedGroups, ...newGroups.reverse()].map((group, index) => ({...group, groupOrder: groupLength - index }))

            const groupConfigList = [...productManagerConfig.groupConfigList].map((group, index) => ({...group, groupOrder: index + 1 }))
            log('group config', groupConfigList)


            let controlBarResponse = null
            if(productManagerConfig.controlBarConfig && productManagerConfig.isControlBarChanged) {
                const controlBarConfigResponse = await productManager.updateControlBarConfig({ siteId, requestData: {...productManagerConfig.controlBarConfig.draft} })
                controlBarResponse = controlBarConfigResponse.data
            }

            const response = await productManager.updateProductManagerConfig({ siteId, requestData: {...productManagerConfig, groupConfigList} })
            // store.dispatch(displaySuccessMessage('Product manager config updated.'))
            log('update product manager config', response, controlBarResponse)
            return {
                controlBar: controlBarResponse,
                productManager: response.data
            }
            
        } catch(err) {
            const errResponse = err.response ? rejectWithValue(err.response.data) : null
            // const error = errResponse?.payload || 'There was an issue updating product manager config'
            // const error = 'There was an issue updating product manager config'
            // store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const getProductCodeUploadStatus = createAsyncThunk('productManager/getProductCodeUploadStatus',
    async payload => {
      const { siteId } = payload
      const response = await productManager.getProductCodeUploadStatus({ siteId })
      return response.data
    }
);

export const updateControlBarConfig = createAsyncThunk('productManager/updateControlBarConfig',
    async (payload, { rejectWithValue }) => {
        const { controlBarConfig, siteId } = payload
        try {
            log('control bar config', controlBarConfig)
            const response = await productManager.updateControlBarConfig({ siteId, requestData: {...controlBarConfig} })
            log('update control bar config', response)
            return response.data
            
        } catch(err) {
            const errResponse = err.response ? rejectWithValue(err.response.data) : null
            // const error = errResponse?.payload || 'There was an issue updating product manager config'
            // const error = 'There was an issue updating product manager config'
            // store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);
